import { ReportingControllerBaseConfig } from '../../../base';
import { RecordUpsertController } from './recordUpsertInterface';
import { RecordUpsertViewProps } from './recordUpsertProps';
import { RecordFormController } from '../form';

export function createRecordUpsertController(
    config: ReportingControllerBaseConfig
): RecordUpsertController {
    return {
        useProps(context, item, props): RecordUpsertViewProps {
            let mode: RecordUpsertViewProps['mode'] = null;
            if (props.record) {
                mode = {
                    kind: 'edit',
                    onClose: props.disclosure.drawer.onClose,
                    document: {
                        id: props.record.id,
                    },
                };
            }
            if (props.collection) {
                mode = {
                    kind: 'new',
                    onClose: props.disclosure.drawer.onClose,
                    collection: {
                        id: props.collection.id,
                    },
                };
            }
            return {
                drawer: {
                    isOpen: props.disclosure.drawer.isOpen,
                    onClose: props.disclosure.drawer.onClose,
                },
                mode,
            };
        },
    };
}
